<div class="flex flex-col">
  <span class="text-gray-800 mb-6 text-lg lg:mt-0 max-w-[289px] text-center lg:text-left lg:max-w-none">
    Enter the {{ numberOfFields }} digit code sent to your phone
  </span>
  <div class="flex space-x-4">
    <div *ngFor="let i of fields; let id = index" class="fieldWrap relative border-b border-[#979797] text-gray-400">
      <input
        type="number"
        class="field"
        [id]="['field_' + id]"
        autocomplete="off"
        maxlength="1"
        max="9"
        min="0"
        inputmode="numeric"
        [value]="values[i]"
        (keyup)="stepForward(i, $event)"
        (keydown.backspace)="stepBack(i)"
        (focus)="resetValue(i)" />
    </div>
  </div>
  <input
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    maximum-scale="1"
    autocomplete="one-time-code"
    [(ngModel)]="code"
    (ngModelChange)="onChange()"
    [autofocus]="true"
    data-test-id="otp-field"
    class="content bg-transparent border-0 focus:outline-none outline-none caret-transparent hidden" />
  <span class="text-bey-black mt-10 lg:text-lg">A new code is generated every {{ counterSeconds }} seconds </span>
  <div class="font-medium text-sm md:text-base text-bey-black mt-8">
    <span *ngIf="counter !== 0" @fadeIn
      >Resend in
      <span class="text-blue-400">
        {{ counter }}
      </span>
      sec
    </span>
    <span *ngIf="counter === 0" @fadeIn data-test-id="resend-cta"
      >Didn't receive the code? <a class="text-blue-400" (click)="onClickResend()">Resend</a></span
    >
  </div>
  <div class="h-6">
    <span *ngIf="isLoading$ | async" @fadeIn class="text-bey-black font-normal text-sm mt-6 mx-auto">
      Just a moment...
    </span>
  </div>
</div>
